import React from 'react';
import { Modal } from './Modal';
import { X } from 'lucide-react';
import { useTranslation } from '~/lib/hooks/useTranslation';
import PricingSection from './PricingSection';
import { json, type LoaderFunction } from '@remix-run/cloudflare';
import { useLoaderData } from '@remix-run/react';
import { useStore } from '@nanostores/react';
import { parseCookies } from '~/lib/utils';
import { userStore } from '~/lib/stores/user';
import TopUpContent from './TopUpContent';
import { getCurrencyFromCountry, type SupportedCurrency } from '~/utils/currency';

interface ProUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  isTopUp?: boolean;
  paymentUrl: string;
}

// export const loader: LoaderFunction = async ({ request }) => {
//   const token = await parseCookies(request.headers.get('Cookie'));
  
//   // Try to get country from Cloudflare headers for currency detection
//   let detectedCurrency: SupportedCurrency = 'USD';
  
//   try {
//     // Cloudflare provides the country code in the CF-IPCountry header
//     const countryCode = request.headers.get('CF-IPCountry');
    
//     if (countryCode && countryCode !== 'XX') {
//       detectedCurrency = getCurrencyFromCountry(countryCode);
//     }
//   } catch (error) {
//     console.error('Error detecting currency:', error);
//   }
  
//   return json({ token, currency: detectedCurrency });
// };

export const ProUpgradeModal: React.FC<ProUpgradeModalProps> = ({ isOpen, onClose, paymentUrl, isTopUp }) => {
  const { t } = useTranslation();

  const planName = useStore(userStore).planName;
  const { token, currency } = useLoaderData<{ token: string; currency: SupportedCurrency }>();

  const showAddTopUp = planName.includes('Pro') && isTopUp;

      // do it the right way @sayan
  if (!paymentUrl || paymentUrl === '' ) {
    paymentUrl = 'https://payments.dualite.dev';
  }

  const buttonCTA = () => {
      window.location.href = `${paymentUrl}/upgrade?token=${token}`;
  }

  const handleScrollToTop = () => {
    // Close modal and let user interact with pricing
    onClose();
  };

  const handleContactSales = () => {
    window.open('https://calendar.app.google/sAggpvWcDjTWUasj9', '_blank');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fixed inset-0 backdrop-blur-xs z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-51 bg-white rounded-2xl shadow-2xl overflow-hidden flex w-[90vw] h-[90vh] md:w-[80vw] md:h-[80vh] lg:w-[70vw] lg:h-[80vh] xl:w-[70vw] xl:h-[80vh]">
        <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-black/70 hover:text-black bg-black/10 hover:bg-black/20 rounded-full transition-all duration-200"
            aria-label="Close"
          >
            <X size={20} /> 
          </button>

        {/* Pricing Section with Scroll */}
        {showAddTopUp ? 
      <div className="flex-1 overflow-y-auto -mt-12">
        <TopUpContent token={token} paymentUrl={paymentUrl}/>
      </div>
        : <div className="flex-1 overflow-y-auto -mt-12">
          <PricingSection 
            currency={currency}
            isCollapsed={true}
            onScrollToTop={handleScrollToTop}
            onContactSales={handleContactSales}
            buttonCTA={buttonCTA}
          />
        </div>}
      </div>
    </Modal>
  );
};

export default ProUpgradeModal;
